
<div *ngIf="!isAluno">
    <div class="body" style="padding: 1.5rem !important;">
        <mat-card class="mat-elevation-z8 noshadow" *ngIf="!error;else errorTemplate">
            <mat-card-title></mat-card-title>
            <mat-card-content>
                <div class="loading-shade" *ngIf="isLoadingResults">
                    <mat-spinner></mat-spinner>
                </div>
                <div class="content" *ngIf="!isLoadingResults">
                    <div *ngIf="!isAluno" class="flex align-center">
                        <button mat-button type="button" (click)="openSelectTurma()" [disabled]="hasTurma" color="primary">
                            Vincular uma turma  &nbsp;
                            <mat-icon>add</mat-icon>
                        </button>
                        <button mat-button type="button" (click)="openSelectTurma(true)" [disabled]="!hasTurma" color="primary">
                            Mudar uma turma  &nbsp;
                            <mat-icon>cached</mat-icon>
                        </button>
                    </div>

                    <div class="grid grid--auto-fill mt-3">
                        <ng-container *ngFor="let item of info">
                            <div class="">
                                <mat-label>{{ item.label }}:</mat-label>
                                <mat-chip-list>
                                    <mat-chip color="primary" selected>{{ item.value }}</mat-chip>
                                </mat-chip-list>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <div class="flex align-center">
                    <div class="flex-fill"></div>
                    <button *ngIf="!hasTurma && !novaMatricula" mat-button [disabled]="!info" type="button" (click)="next()" color="primary">Continuar &nbsp;<mat-icon>send</mat-icon></button>
                    <button *ngIf="novaMatricula" mat-button type="button" [disabled]="!info" (click)="salvar()" color="primary">Salvar</button>
                </div>
            </mat-card-actions>
        </mat-card>
    </div> 
</div>

<div *ngIf="isAluno">
    <app-aluno-portal></app-aluno-portal>
    <mat-card class="div-minhas-aulas">
        <p class="titulo-minhas-aulas">
            Minhas Aulas
        </p>
    </mat-card>

    <div *ngIf="!isLoadingResults" class="grid-video-aula">
        <mat-card class="card-minhas-aulas">
            <div class="grid-lista-video">
                <mat-list *ngFor="let materia of materias">
                    <mat-divider></mat-divider>
                    <mat-list-item class="lista-materias" (click)="goToAulasOnline(matriculaId, materia.id)">{{ materia.nomeMateria }}
                        <mat-icon class="icone-materias">arrow_forward_ios</mat-icon>
                    </mat-list-item>
                </mat-list>
            </div>
        </mat-card>
    </div>
</div>

<!-- <div *ngIf="!isLoadingResults" class="grid-video-aula mt-1">
    <mat-card>
        <div class="grid-lista-video">
            <mat-accordion *ngFor="let materia of materias" class="noselect">
                <mat-expansion-panel [expanded]="openPanel(materia)">
                    <mat-expansion-panel-header><mat-panel-title color="primary">{{ materia.nomeMateria }}</mat-panel-title></mat-expansion-panel-header>
                        <mat-selection-list #shoes [multiple]="false">
                            <mat-list-option *ngFor="let aula of materia.videoAula" (click)="changeVideo(aula)">{{ aula.tituloAula }}</mat-list-option>
                        </mat-selection-list>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-card>
</div> -->


<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>
